import {
  PermissionContext,
  Post,
  PostAuthMemberProps,
  PostMappingTypeEnum,
  PostStatus,
  PostType,
  PostTypeContext,
  ReactionType,
  Space,
  SpaceType,
} from '@tribeplatform/gql-client/types'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'

import { Post as PostComponent } from '../../Post'

export const SamplePost = () => {
  const { data: authToken } = useAuthToken()
  const { member, network } = authToken || {}

  if (!member || !network) {
    return null
  }

  const now = new Date().toISOString()

  const space: Space = {
    id: 'sample-space-id',
    name: 'General',
    slug: 'general',
    layout: 'DEFAULT',
    networkId: network.id,
    type: SpaceType.GROUP,
    createdById: member.id,
    membersCount: 1,
    createdAt: now,
    customOrderingIndexInGroup: 1,
    address: {
      exact: false,
      path: 'general',
      editable: false,
    },
  }

  const postType: PostType = {
    context: PostTypeContext.POST,
    id: 'sample-postType-id',
    name: 'Discussion',
    pluralName: 'Discussions',
    slug: 'tribe-discussion',
    createdAt: now,
    primaryReactionType: ReactionType.LIKE_BASE,
    singleChoiceReactions: [],
    updatedAt: now,
  }

  const authMemberProps: PostAuthMemberProps = {
    context: PermissionContext.POST,
    canReact: true,
    permissions: [
      {
        name: 'addReaction',
        isAuthorized: {
          authorized: true,
        },
        inputPermissions: [],
        outputPermissions: [],
      },
      {
        name: 'createReply',
        isAuthorized: {
          authorized: true,
        },
        inputPermissions: [],
        outputPermissions: [],
      },
    ],
    availableReplyTypes: [postType],
  }

  const post: Post = {
    id: 'sample-post-id',
    slug: 'this-is-a-sample-post',
    mappingFields: [
      {
        key: 'title',
        type: PostMappingTypeEnum.TEXT,
        value: '"This is a sample post"',
      },
      {
        key: 'content',
        type: PostMappingTypeEnum.HTML,
        value:
          '"<p>This is how text will appear in posts made on your community. And links will appear like <a href=\\"#\\" class=\\"text-actionPrimary-600 hover:text-actionPrimary-500\\" rel=\\"noopener noreferrer nofollow\\">this</a>.</p>"',
      },
    ],
    postTypeId: postType.id,
    reactionsCount: 0,
    hasMoreContent: false,
    isAnonymous: false,
    shortContent:
      '<p>This is how text will appear in posts made on your community. And links will appear like <a href="#" class="text-actionPrimary-600 hover:text-actionPrimary-500" rel="noopener noreferrer nofollow">this</a>.</p>',
    createdAt: now,
    ownerId: member.id,
    createdById: member.id,
    status: PostStatus.PUBLISHED,
    spaceId: space.id,
    imageIds: [],
    pinnedInto: [],
    repliesCount: 1,
    totalRepliesCount: 1,
    repliedToId: null,
    title: 'This is a sample post',
    embedIds: [],
    mentionedMembers: [],
    primaryReactionType: ReactionType.LIKE_BASE,
    postType,
    owner: {
      member,
    },
    space,
    attachmentIds: [],
    negativeReactionsCount: 0,
    positiveReactionsCount: 0,
    networkId: network.id,
    topRepliers: [],
    singleChoiceReactions: [],
    seoDetail: {
      title: '',
    },
    authMemberProps,
  }

  const reply: Post = {
    id: 'sample-reply-id',
    slug: 'and-this-is-how-replies-will-appear',
    mappingFields: [
      {
        key: 'content',
        type: PostMappingTypeEnum.TEXT,
        value: '"<p>And this is how replies will appear</p>"',
      },
    ],
    postTypeId: 'reply-postType-id',
    reactionsCount: 0,
    hasMoreContent: false,
    isAnonymous: false,
    shortContent: '<p>And this is how replies will appear</p>',
    createdAt: now,
    ownerId: member.id,
    createdById: member.id,
    status: PostStatus.PUBLISHED,
    spaceId: space.id,
    imageIds: [],
    pinnedInto: [],
    repliesCount: 0,
    totalRepliesCount: 0,
    title: null,
    embedIds: [],
    mentionedMembers: [],
    primaryReactionType: ReactionType.LIKE_BASE,
    owner: {
      member,
    },
    attachmentIds: [],
    negativeReactionsCount: 0,
    positiveReactionsCount: 0,
    networkId: network.id,
    topRepliers: [],
    singleChoiceReactions: [],
    seoDetail: {
      title: '',
    },
    authMemberProps,
  }

  post.replies = {
    nodes: [reply],
    pageInfo: {
      endCursor: '',
      hasNextPage: false,
    },
    totalCount: 1,
  }

  return (
    <div className="cursor-default pointer-events-none">
      <PostComponent post={post} context="network" activeTagId="" view="card" />
    </div>
  )
}
